import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ReservationLoaderPage } from "../../../reservation/reservation-loader/reservation-loader";
import { OrdersCoServices } from '../../services';
import { HomePage } from '../../../home/home';
import { BlockScreenPage } from '../../../components/block-screen/block-screen';
import { Globals } from '../../../../globals';
import { TPVServices } from '../../../tpv/services';
import { TranslateService } from '@ngx-translate/core';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { PopupNewAppsPage } from '../../../components/popups/popup-new-apps/popup-new-apps';

/**
 * Generated class for the OrdersSelectRoomMenuPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-orders-select-room-menu',
  templateUrl: 'orders-select-room-menu.html',
})
export class OrdersSelectRoomMenuPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public ordersCoServices: OrdersCoServices,
    public globals: Globals,
    public tpvServices: TPVServices,
    public translate: TranslateService) {
  }


  takeAway() {
    //this.ordersCoServices.menu_select_room = 'take_away';
    if (this.globals.checkLimitsByLicense('tpv', 'takeaway')) {
      this.tpvServices.menu_select_room = 'take_away';
      //this.navCtrl.setRoot(TpvLoaderPage);
      this.navCtrl.push(PopupNewAppsPage, { app: 'pos' });
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  openRoom(room) {
    this.ordersCoServices.room_selected_uid = room.UID;
    this.ordersCoServices.room_selected_name = room.name;
    this.ordersCoServices.menu_select_room = 'room';
    this.ordersCoServices.room_selected_map = room.map;
  }

  openCalendar() {
    if (this.globals.checkLimitsByLicense('reservations', 'calendar')) {
      this.globals.side_menu_active = 'reservation';
      this.navCtrl.push(ReservationLoaderPage);
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  close() {
    this.globals.side_menu_active = 'dashboard';
    this.navCtrl.setRoot(HomePage);
  }

  tpv() {
    this.globals.side_menu_active = 'tpv';
    //this.navCtrl.setRoot(TpvLoaderPage);
    this.navCtrl.push(PopupNewAppsPage, { app: 'pos' });
  }

  block() {
    this.navCtrl.push(BlockScreenPage, {
      type: 'orders',
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/orders/orders-rooms/orders-select-room-menu/orders-select-room-menu.ts